import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"; // Soft look delete icon

const QualificationList = ({ qualifications, onDelete }) => {
  if (!qualifications || qualifications.length === 0) {
    return null;
  }

  const handleDeleteClick = (id) => {
    if (window.confirm("Do you really want to delete this qualification?")) {
      if (onDelete) onDelete(id); // Parent component me delete handle karne ke liye
    }
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Typography variant="subtitle1" fontWeight="700" color="#1e293b" mb={2}>
        Education History ({qualifications.length})
      </Typography>

      <Grid container spacing={2}>
        {qualifications.map((item) => (
          <Grid item xs={12} sm={6} key={item.id}>
            <Card
              sx={{
                borderRadius: "16px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.03)",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
                },
              }}
            >
              <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
                
                {/* HEADER ROW WITH ICON & DELETE BUTTON */}
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                  <Box display="flex" alignItems="center" gap={1} sx={{ maxWidth: "70%" }}>
                    <SchoolIcon color="primary" sx={{ fontSize: 22, flexShrink: 0 }} />
                    <Typography 
                      variant="h6" 
                      fontWeight="700" 
                      color="#1e293b" 
                      sx={{ fontSize: "16px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                    >
                      {item.degree_name}
                    </Typography>
                  </Box>
                  
                  {/* ACTIONS WRAPPER (CHIP + DELETE) */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Chip
                      label={item.degree_status ? item.degree_status.toUpperCase() : "COMPLETED"}
                      size="small"
                      color={item.degree_status === "completed" ? "success" : "warning"}
                      sx={{ fontWeight: "700", fontSize: "10px", borderRadius: "6px" }}
                    />
                    
                    {/* DYNAMIC DELETE ICON BUTTON */}
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteClick(item.id)}
                      sx={{
                        bgcolor: "rgba(239, 68, 68, 0.05)", // Ultra soft red tint background
                        p: 0.6,
                        "&:hover": {
                          bgcolor: "rgba(239, 68, 68, 0.15)",
                        }
                      }}
                    >
                      <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Box>
                </Box>

                {/* UNIVERSITY NAME */}
                <Typography variant="body2" fontWeight="500" color="#475569" mb={2} sx={{ textTransform: "capitalize" }}>
                  {item.university_name}
                </Typography>

                <Divider sx={{ borderStyle: "dashed", mb: 2 }} />

                {/* METRICS ROW */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
                  <Box display="flex" alignItems="center" gap={0.5} color="#64748b">
                    <DateRangeIcon sx={{ fontSize: 16 }} />
                    <Typography variant="caption" fontWeight="600">
                      Year: {item.year || "N/A"}
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center" gap={0.5} color="#64748b">
                    <AssessmentIcon sx={{ fontSize: 16 }} />
                    <Typography variant="caption" fontWeight="600">
                      Score: {item.percentage ? `${item.percentage}%` : "N/A"}
                    </Typography>
                  </Box>
                </Box>

                {/* ATTACHMENT VIEW BUTTON */}
                {item.image_url ? (
                  <Button
                    fullWidth
                    variant="light"
                    size="small"
                    startIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
                    onClick={() => window.open(item.image_url, "_blank", "noopener,noreferrer")}
                    sx={{
                      textTransform: "none",
                      fontWeight: "600",
                      borderRadius: "8px",
                      bgcolor: "#f1f5f9",
                      color: "#334155",
                      fontSize: "12px",
                      py: 1,
                      "&:hover": {
                        bgcolor: "#e2e8f0",
                        color: "#0f172a",
                      },
                    }}
                  >
                    View Attachment Document
                  </Button>
                ) : (
                  <Button fullWidth disabled size="small" sx={{ borderRadius: "8px", fontSize: "12px" }}>
                    No Document Attached
                  </Button>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QualificationList;